/** Stable router selection; the actual checkpoint is chosen in Admin → Resources. */
export const VM_VLM_MODEL = {
  value: "nomadicvl_vm",
  label: "Qwen / Cosmos (VM)",
  description: "Uses the model deployed in Admin → Resources. The VM must be ready.",
} as const;
